import React from 'react'
import PropTypes from 'prop-types'

import './style.scss'

const Footer = ({ id, contents }) => {
  return (
    <div id={id} className="text-body-xs footer-disclaimer text-left">
      {contents.map((contentItem, contentItemIndex) => (
        <div key={`${id}_${contentItemIndex}`} className="footer-disclaimer__item">
          {typeof contentItem === 'string' ? <div dangerouslySetInnerHTML={{ __html: contentItem }} /> : contentItem}
        </div>
      ))}
    </div>
  )
}

Footer.propTypes = {
  id: PropTypes.string.isRequired,
  contents: PropTypes.array.isRequired
}

Footer.defaultProps = {}

export default Footer
